import { render, staticRenderFns } from "./SpecialPermissionsList.vue?vue&type=template&id=72b4bde8&lang=pug"
import script from "./SpecialPermissionsList.vue?vue&type=script&lang=js"
export * from "./SpecialPermissionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports